module.exports = __webpack_public_path__ + "img/background-login.33fd419c.jpg";